// import { useState } from 'react'

// import SetState from 'Components/Hooks/SetState'
import BasicTable from 'Components/UI/Atoms/BasicTable'
// import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'

const Asientos = ({ data, edit }) => {
  // const [selectedRow, setSelectedRow] = useState(null)

  // const {
  //   state: paymentDetail,
  //   setOpen: setOpenPaymentDetail,
  //   setClose: setClosePaymentDetail,
  // } = SetState()

  // const onClickRow = (index) => {
  //   if (!edit) return

  //   const selectedItem = data.asientos.find((obj) => obj.id === index.id)
  //   setSelectedRow(selectedItem)
  //   setOpenPaymentDetail(true)
  // }

  // const renderDetails = () => {
  //   if (!selectedRow || !selectedRow.detalles) return null

  //   return (
  //     <div
  //       style={{ width: '45rem', display: 'flex', justifyContent: 'center', marginBottom: '20px' }}
  //     >
  //       <BasicTable
  //         col={[
  //           { title: 'Asiento', style: { width: '10px' } },
  //           { title: 'Cuenta', style: { width: '80px' } },
  //           { title: 'Debe', style: { width: '70px' } },
  //           { title: 'Haber', style: { width: '70px' } },
  //         ]}
  //         size="small"
  //         rows={selectedRow.detalles.map((detalle) => {
  //           const getCuentaNombre = (cuentaId) => {
  //             const cuenta = dataBefore.data.cuentas.find((c) => c.id === cuentaId)
  //             return cuenta?.nombre
  //           }
  //           return {
  //             asiento: detalle.asientoId,
  //             cuenta: getCuentaNombre(detalle.cuenta),
  //             debe: `$ ${Number(detalle.debe).toFixed(2).replace('.', ',')}`,
  //             haber: `$ ${Number(detalle.haber).toFixed(2).replace('.', ',')}`,
  //           }
  //         })}
  //       />
  //     </div>
  //   )
  // }

  return (
    <>
      <div style={{ display: 'flex', margin: '2rem', cursor: edit ? 'pointer' : '' }}>
        <BasicTable
          col={[
            { title: 'ID', style: { width: '40px' } },
            { title: 'Fecha', style: { width: '40px' } },
            { title: 'Periodo', style: { width: '40px' } },
            { title: 'Descripción', style: { width: '100px' } },
            { title: 'Debe', style: { width: '60px' } },
            { title: 'Haber', style: { width: '60px' } },
          ]}
          size="small"
          rows={data.asientos.map((row) => {
            const [, month, year] = row.fecha.split('/')
            const periodo = `${month}/${year}`
            const debeTotal = row.detalles.reduce(
              (acc, detalle) => acc + parseFloat(detalle.debe),
              0
            )
            const haberTotal = row.detalles.reduce(
              (acc, detalle) => acc + parseFloat(detalle.haber),
              0
            )

            return {
              id: row.id,
              fecha: row.fecha,
              periodo: periodo,
              descripcion: row.descripcion,
              debe: `$ ${debeTotal.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
              haber: `$ ${haberTotal.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
            }
          })}
          //   onClickRow={permissions.allowEditMin ? () => {} : onClickRow}
        />
      </div>

      {/* <DialogComponent
        open={paymentDetail.open}
        title="Detalles del asiento"
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        handleclose={setClosePaymentDetail}
        widthLarge="770px"
        children={renderDetails()}
      /> */}
    </>
  )
}

export default Asientos
